var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-status-box',{attrs:{"status":_vm.availability,"statusMap":_vm.statusMap}})}
var staticRenderFns = []

export { render, staticRenderFns }